export default __webpack_public_path__ + "static/media/safe7-intro.96cc6c36.png";